// Creare's 'Implied Consent' EU Cookie Law Banner v:2.4
// Conceived by Robert Kent, James Bavington & Tom Foyster

var dropCookie = true; // false disables the Cookie, allowing you to style the banner
var cookieDuration = 14; // Number of days before the cookie expires, and the banner reappears
var cookieName = "complianceCookie"; // Name of our cookie
var cookieValue = "on"; // Value of cookie

function createDiv() {
	const { body } = document;
	const div = document.createElement("div");
	div.setAttribute("id", "cookie-law");
	div.innerHTML = `<p class="wrapper">En poursuivant votre navigation, vous acceptez le dépôt de cookies destinés au fonctionnement du site internet. <a href="${lien_privacy_policy}" rel="nofollow"><strong>Pour plus d'informations</strong></a><div class="close-cookie-banner"><span>&#x2716;</span></div></p>`;

	div.querySelector(".close-cookie-banner").onclick = () => {
		div.remove();
		body.classList.remove("cookiebanner");
		createCookie(cookieName, cookieValue, cookieDuration);
	};

	body.appendChild(div);
	body.classList.add("cookiebanner");
}

function createCookie(name, value, days) {
	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "expires=" + date.toGMTString();
	}

	if (dropCookie) {
		document.cookie = `${name}=${value}; ${expires}; path=/`;
	}
}

function checkCookie(name) {
	const nameEQ = name + "=";
	if (!document.cookie.includes(nameEQ)) {
		return null;
	}

	for (let cookie of document.cookie.split(";")) {
		const trimmedCookie = cookie.trim();
		if (trimmedCookie.indexOf(nameEQ) === 0) {
			return trimmedCookie.replace(nameEQ, "").trim();
		}
	}
}

function eraseCookie(name) {
	createCookie(name, "", -1);
}

window.onload = function () {
	if (checkCookie(cookieName) !== cookieValue) {
		createDiv();
	}
};
